// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VTNv","disabled":"styles_disabled__2gPrh"};